import { classes } from "@shared/api/services";
import { useQuery } from "@tanstack/react-query"

export const useAllAppointments = (params, options) => {
    return useQuery({
        queryKey: ['appointments', params],
        queryFn: () => classes.getAllClasses(params),
        select: (data) => data.data,
				...options
    });
};